import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ButtonModule, CheckboxModule, InputModule, RadioModule, SelectModule, TextareaModule } from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeliveryErrorInternationalForm, DeliveryErrorInternationalFormGroup } from '../../../models/cod-create.model';
import { AttachmentsInputComponent } from '../../../../shared/components/attachments-input/attachments-input.component';
import { DeliveryIssueTypeInternational } from '@cod-monorepo/interfaces';
import { AinErrorType } from '@cod-monorepo/interfaces';
import { Store } from '@ngxs/store';
import { AddCurrentCodLine } from '../../../state/cod.action';
import { BaseInternationalStep } from '../base-international-step/base-international-step';

@Component({
    selector: 'app-cod-delivery-error-international-step',
    templateUrl: './delivery-error-international.component.html',
    imports: [
        CommonModule,
        SelectModule,
        InputModule,
        FormsModule,
        ReactiveFormsModule,
        RadioModule,
        CheckboxModule,
        ButtonModule,
        TextareaModule,
        AttachmentsInputComponent
    ],
    standalone: true
})
export class CodDeliveryErrorInternationalStepComponent extends BaseInternationalStep {
    @Input() deliveryErrorInternationalForm: FormGroup<DeliveryErrorInternationalFormGroup> | undefined;

    public deilveryErrorType = DeliveryIssueTypeInternational;
    public ainErrorTypes = AinErrorType;

    constructor(private store: Store) {
        super();
    }

    public isDefined(control: keyof DeliveryErrorInternationalForm): boolean {
        return this.deliveryErrorInternationalForm?.controls[control].value !== null;
    }

    public isTrue(control: keyof DeliveryErrorInternationalForm): boolean {
        return this.deliveryErrorInternationalForm?.controls[control].value === true;
    }

    public isFalse(control: keyof DeliveryErrorInternationalForm): boolean {
        return this.deliveryErrorInternationalForm?.controls[control].value === false;
    }

    public showShippmentNumber(): boolean {
        return (
            this.deliveryErrorInternationalForm?.controls?.issueType?.value !==
            DeliveryIssueTypeInternational.ATELLICA_INVENTORY_MANAGER
        );
    }

    public handleConfirm() {
        if (this.deliveryErrorInternationalForm?.valid) {
            this.store.dispatch(new AddCurrentCodLine());
        }
    }

    public isValid(): boolean {
        return this.deliveryErrorInternationalForm?.valid ?? false;
    }
}
